import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store/index.js'

import Naestved from '@/views/Naestved/Naestved.vue'

import FH from '@/views/FH/FH.vue'
import PII from '@/views/PII/PII.vue'

// Processing
import Processing from '@/views/Processing/Processing.vue'
    import ProcessingPrivateRedials from '@/views/Processing/PrivateRedials.vue'
    import ProcessingCommonRedials from '@/views/Processing/CommonRedials.vue'


// Kontrol
import Quality from '@/views/Quality/Quality.vue'

    import QualityStatus from '@/views/Quality/Status/Status.vue'
        import QualityStatusRegistration from '@/views/Quality/Status/Registration.vue'
        import QualityStatusCancelations from '@/views/Quality/Status/Cancelations.vue'
        import QualityStatusInboxes from '@/views/Quality/Status/Inboxes.vue'
        import QualityStatusComplaints from '@/views/Quality/Status/Complaints.vue'
        import QualityStatusDeviations from '@/views/Quality/Status/Deviations.vue'

    import QualityDevelopment from '@/views/Quality/Development/Development.vue'
        import QualityDevelopmentCancelations from '@/views/Quality/Development/Cancelations.vue'
        import QualityDevelopmentInboxes from '@/views/Quality/Development/Inboxes.vue'
        import QualityDevelopmentComplaints from '@/views/Quality/Development/Complaints.vue'

// Stats
import Stats from '@/views/Stats/Stats.vue'
import StatsAgents from '@/views/Stats/Agents.vue'
import StatsCampaigns from '@/views/Stats/Campaigns.vue'

// Development
import Development from '@/views/Development/Development.vue'
import DevelopmentSales from '@/views/Development/Sales.vue'
import DevelopmentEfficiency from '@/views/Development/Efficiency.vue'

// Reports
import Reports from '@/views/Reports/Reports.vue'

// Controlpanel
import ControlPanel from '@/views/ControlPanel/ControlPanel.vue'
    import ControlFh from '@/views/ControlPanel/Fh.vue'
    import ControlCampaigns from '@/views/ControlPanel/Campaigns.vue'
    import ControlAgents from '@/views/ControlPanel/Agents.vue'
    import ControlReports from '@/views/ControlPanel/Reports.vue'
    import ControlRules from '@/views/ControlPanel/Rules.vue'
    import ControlAccounts from '@/views/ControlPanel/Accounts.vue'
    import ControlTraining from '@/views/ControlPanel/Training.vue'
    import ControlConfiguration from '@/views/ControlPanel/Configuration.vue'

// Dashboard
import Dashboard from '@/views/User/Dashboard/Dashboard.vue'

import Overview from '@/views/Overview.vue'


// Live
import Live from '@/views/Live/Live.vue'

// Competition
// import Competition from '@/views/Competition/Competition.vue'
// import CompetitionTarget from '@/views/Competition/Target.vue'
// import CompetitionTotal from '@/views/Competition/Total.vue'
// import CompetitionTeamTarget from '@/views/Competition/TeamTarget.vue'
// import CompetitionTeamTMK from '@/views/Competition/TeamTMK.vue'

// Scoreboard
// import Scoreboard from '@/views/Scoreboard/Scoreboard.vue'
// import ScoreboardEfficiency from '@/views/Scoreboard/Efficiency.vue'

// Mix
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'

// Distribution
import Distribution from '@/views/Distribution/Distribution.vue'
import DistributionAgents from '@/views/Distribution/Agents.vue'
import DistributionCampaigns from '@/views/Distribution/Campaigns.vue'

// Campaigns
import Campaigns from '@/views/Campaigns/Campaigns.vue'

// Training
import UserTraining from '@/views/User/Training/User.vue'
import Video from '@/views/User/Training/Video.vue'
import Test from '@/views/User/Training/Test.vue'

import UserStats from '@/views/User/Stats.vue'
import UserCallLogs from '@/views/User/CallLogs.vue'

// Meetings
import Booking from '@/views/Booking/Booking.vue'  
        
    import BookingStats from  '@/views/Booking/Stats/Stats.vue'
        import BookingStatsSummary from  '@/views/Booking/Stats/Summary.vue'

    import BookingPivot from  '@/views/Booking/Pivot.vue'

    import BookingRegistration from '@/views/Booking/Registration/Registration.vue'

        import BookingCurrentOffers from '@/views/Booking/Registration/CurrentOffers.vue'
        import BookingCurrentMeetings from '@/views/Booking/Registration/CurrentMeetings.vue'

        import BookingAll from '@/views/Booking/Registration/All/All.vue'

            import BookingAllMeetings from '@/views/Booking/Registration/All/Meetings.vue'
            import BookingAllOffers from '@/views/Booking/Registration/All/Offers.vue'
            import BookingAllCalendar from '@/views/Booking/Registration/All/Calendar.vue'

// CallLogs
import CallLogs from '@/views/CallLogs/CallLogs.vue'
import CallLogReports from '@/views/CallLogs/CallLogReports.vue'

// import Micro from '@/views/Micro.vue'

// Reports
import Academy from '@/views/Academy/Academy.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/naestved',
        name: 'Naestved',
        component: Naestved,
        meta: {
            access: ['naestved', 'all', 'admin']
        }
    },
    {
        path: '/fh',
        name: 'FH',
        component: FH,
        meta: {
            access: ['fh', 'all', 'admin']
        }
    },
    {
        path: '/pii',
        name: 'PII',
        component: PII,
        meta: {
            access: ['pii', 'all', 'admin']
        }
    },
    {
        path: '/processing',
        name: 'Processing',
        component: Processing,
        meta: {
            access: ['all', 'admin']
        },
        children: [
            {
                path: 'private-redials',
                name: 'ProcessingPrivateRedials',
                component: ProcessingPrivateRedials,
                meta: {
                    access: ['all', 'admin']
                }
            },
            {
                path: 'common-redials',
                name: 'ProcessingCommonRedials',
                component: ProcessingCommonRedials,
                meta: {
                    access: ['all', 'admin']
                }
            }
        ]
    },
    {
        path: '/quality',
        name: 'Quality',
        component: Quality,
        meta: {
            access: ['all', 'admin']
        },
        children: [
            {
                path: 'status',
                name: 'QualityStatus',
                component: QualityStatus,
                meta: {
                    access: ['all', 'admin']
                },
                children: [
                    {
                        path: 'registration',
                        name: 'QualityStatusRegistration',
                        component: QualityStatusRegistration,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'cancelations',
                        name: 'QualityStatusCancelations',
                        component: QualityStatusCancelations,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'inboxes',
                        name: 'QualityStatusInboxes',
                        component: QualityStatusInboxes,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'complaints',
                        name: 'QualityStatusComplaints',
                        component: QualityStatusComplaints,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'deviations',
                        name: 'QualityStatusDeviations',
                        component: QualityStatusDeviations,
                        meta: {
                            access: ['all', 'admin']
                        }
                    }
                ]
            },
            {
                path: 'development',
                name: 'QualityDevelopment',
                component: QualityDevelopment,
                meta: {
                    access: ['all', 'admin']
                },
                children: [
                    {
                        path: 'cancelations',
                        name: 'QualityDevelopmentCancelations',
                        component: QualityDevelopmentCancelations,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'inboxes',
                        name: 'QualityDevelopmentInboxes',
                        component: QualityDevelopmentInboxes,
                        meta: {
                            access: ['all', 'admin']
                        }
                    },
                    {
                        path: 'complaints',
                        name: 'QualityDevelopmentComplaints',
                        component: QualityDevelopmentComplaints,
                        meta: {
                            access: ['all', 'admin']
                        }
                    }
                ]
            }
        ]
    },
    // {
    //     path: '/micro',
    //     name: 'Micro',
    //     component: Micro,
    //     meta: {
    //         access: ['tele', 'all', 'admin']
    //     }
    // },
    {
        path: '/user/training',
        name: 'UserTraining',
        component: UserTraining,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/test',
        name: 'Test',
        component: Test,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/video',
        name: 'Video',
        component: Video,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/overview',
        name: 'Overview',
        component: Overview,
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/live',
        name: 'Live',
        component: Live,
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/user/stats',
        name: 'UserStats',
        component: UserStats,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/user/calllogs',
        name: 'UserCallLogs',
        component: UserCallLogs,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/calllogs',
        name: 'CallLogs',
        component: CallLogs,
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/calllogs/reports',
        name: 'CallLogReports',
        component: CallLogReports,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/booking',
        name: 'Booking',
        component: Booking,
        children: [
            {
                path: 'stats',
                name: 'BookingStats',
                component: BookingStats,
                children: [
                    {
                        path: 'summary',
                        name: 'BookingStatsSummary',
                        component: BookingStatsSummary,
                        meta: {
                            access: ['booking', 'all', 'admin']
                        }
                    }
                ],
                meta: {
                    access: ['booking', 'all', 'admin']
                }
            },
            {
                path: 'pivot',
                name: 'BookingPivot',
                component: BookingPivot,
                meta: {
                    access: ['all', 'admin']
                }
            },
            {
                path: 'registration',
                name: 'BookingRegistration',
                component: BookingRegistration,
                children: [
                    {
                        path: 'all',
                        name: 'All',
                        component: BookingAll,
                        children: [
                            {
                                path: 'meetings',
                                name: 'meetings',
                                component: BookingAllMeetings,
                                meta: {
                                    access: ['all', 'admin', 'tele']
                                }
                            },
                            {
                                path: 'offers',
                                name: 'offers',
                                component: BookingAllOffers,
                                meta: {
                                    access: ['all', 'admin', 'tele']
                                }
                            },
                            {
                                path: 'calendar',
                                name: 'BookingAllCalendar',
                                component: BookingAllCalendar,
                                meta: {
                                    access: ['all', 'admin', 'tele']
                                }
                            }
                        ],
                        meta: {
                            access: ['all', 'admin', 'tele']
                        }
                    },
                    {
                        path: 'currentOffers',
                        name: 'BookingCurrentOffers',
                        component: BookingCurrentOffers,
                        meta: {
                            access: ['all', 'admin', 'tele']
                        }
                    },
                    {
                        path: 'currentMeetings',
                        name: 'BookingCurrentMeetings',
                        component: BookingCurrentMeetings,
                        meta: {
                            access: ['all', 'admin', 'tele']
                        }
                    }
                ],
                meta: {
                    access: ['all', 'admin', 'tele']
                }
            }
        ],
        meta: {
            access: ['all', 'admin', 'tele']
        }
    },
    {
        path: '/distribution',
        name: 'Distribution',
        component: Distribution,
        children: [
            {
                path: 'campaigns',
                name: 'DistributionCampaigns',
                component: DistributionCampaigns,
                meta: {
                    access: ['tele', 'all', 'admin']
                }
            },
            {
                path: 'agents',
                name: 'DistributionAgents',
                component: DistributionAgents,
                meta: {
                    access: ['tele', 'all', 'admin']
                }
            }
        ],
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    {
        path: '/campaigns/:uniqueId',
        name: 'Campaigns',
        component: Campaigns,
        meta: {
            access: ['tele', 'all', 'admin']
        },
        props: true
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            access: ['tele', 'all', 'admin']
        }
    },
    // {
    //     path: '/scoreboard',
    //     name: 'Scoreboard',
    //     component: Scoreboard,
    //     children: [
    //         {
    //             path: 'efficiency',
    //             name: 'ScoreboardEfficiency',
    //             component: ScoreboardEfficiency
    //         }
    //     ]
    // },
    {
        path: '/stats',
        name: 'Stats',
        component: Stats,
        children: [{
                path: 'agents',
                name: 'StatsAgents',
                component: StatsAgents,
                meta: {
                    access: ['all', 'admin']
                }
            },
            {
                path: 'campaigns',
                name: 'StatsCampaigns',
                component: StatsCampaigns,
                meta: {
                    access: ['all', 'admin']
                }
            }
        ],
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/development',
        name: 'Development',
        component: Development,
        children: [{
                path: 'sales',
                name: 'sales',
                component: DevelopmentSales,
                meta: {
                    access: ['all', 'admin']
                }
            },
            {
                path: 'efficiency',
                name: 'efficiency',
                component: DevelopmentEfficiency,
                meta: {
                    access: ['all', 'admin']
                }
            }
        ],
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: {
            access: ['all', 'admin']
        }
    },
    {
        path: '/academy',
        name: 'Academy',
        component: Academy,
        meta: {
            access: ['tele']
        }
    },
    {
        path: '/controlpanel',
        name: 'ControlPanel',
        component: ControlPanel,
        children: [
            {
                path: 'fh',
                name: 'ControlFh',
                component: ControlFh,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'campaigns',
                name: 'ControlCampaigns',
                component: ControlCampaigns,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'agents',
                name: 'ControlAgents',
                component: ControlAgents,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'reports',
                name: 'ControlReports',
                component: ControlReports,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'rules',
                name: 'ControlRules',
                component: ControlRules,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'accounts',
                name: 'ControlAccounts',
                component: ControlAccounts,
                meta: {
                    access: ['admin']
                }
            },
            {
                path: 'training',
                name: 'ControlTraining',
                component: ControlTraining,
                meta: {
                    access: ['all', 'admin']
                }
            },
            {
                path: 'configuration',
                name: 'ControlConfiguration',
                component: ControlConfiguration,
                meta: {
                    access: ['all', 'admin']
                }
            }
        ],
        meta: {
            access: ['admin']
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && !localStorage.getItem('access')) next({ name: 'Login' })
    else if (to.meta.access && !to.meta.access.includes(localStorage.getItem('access'))) next({ name: 'Home' })
    else next()
})

export default router